import React from "react";

interface ICropRotationContext {
  lotHeights: { [key: number]: number };
  setLotHeight: ({ lotId, height }: { lotId: number; height: number }) => void;
  cropWidth: number;
}

const CropRotationContext = React.createContext<Partial<ICropRotationContext>>({
  cropWidth: 10,
});

export function CropRotationProvider({ children }: { children: JSX.Element }) {
  const cropWidth = 10;
  const [lotHeights, setLotHeights] = React.useState<{ [key: number]: number }>(
    {},
  );

  const setLotHeight = ({
    lotId,
    height,
  }: {
    lotId: number;
    height: number;
  }) => {
    setLotHeights((oldLotHeights) => {
      oldLotHeights[lotId] = height;
      return { ...oldLotHeights };
    });
  };
  return (
    <CropRotationContext.Provider
      value={{
        lotHeights,
        setLotHeight,
        cropWidth,
      }}
    >
      {children}
    </CropRotationContext.Provider>
  );
}

export function useCropRotationContext() {
  return React.useContext(CropRotationContext);
}
